export const Create = [
  {
    path: "/parts",
    name: "Parts",
    component: () => import("@/views/create/CreateItem.vue"),
  },
  //   {
  //     path: "/documents",
  //     name: "Documents",
  //     component: Documents,
  //   },

  {
    path: "/createChange",
    name: "CreateChange",
    component: () => import("@/views/create/CreateChange.vue"),
  },
  {
    path: "/CreateManufacturer",
    name: "CreateManufacturer",
    component: () => import("@/views/create/CreateManufacturer.vue"),
  },
  {
    path: "/CreateManufacturerPart",
    name: "CreateManufacturerPart",
    component: () => import("@/views/create/CreateManufacturerPart.vue"),
  },
  {
    path: "/QuickCreate",
    name: "QuickCreate",
    component: () => import("@/views/create/QuickCreate.vue"),
  },
  {
    path: "/createProject",
    name: "CreateProject",
    component: () => import("@/views/create/CreateProject.vue"),
  },
  {
    path: "/quality",
    name: "CreateQuality",
    component: () => import("@/views/create/CreateQuality.vue"),
  },
  {
    path: "/technology",
    name: "CreateTechnology",
    component: () => import("@/views/create/CreateTechnology.vue"),
  },
  {
    path: "/resource",
    name: "CreateResource",
    component: () => import("@/views/create/CreateResource.vue"),
  },
];
